import { render, staticRenderFns } from "./label-group.vue?vue&type=template&id=26d6bffa&scoped=true&"
import script from "./label-group.vue?vue&type=script&lang=ts&"
export * from "./label-group.vue?vue&type=script&lang=ts&"
import style0 from "./label-group.vue?vue&type=style&index=0&id=26d6bffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d6bffa",
  null
  
)

export default component.exports